import { useEffect, createRef, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Transition } from "@headlessui/react";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import SliderItem from "./SliderItem";

import { useTabStore } from "../store/tab-store";
import getBaseUri from "../utilities/getBaseUri";
import SimpleText from "./SimpleText";

function TabTraining(props) {
  const { t, i18n } = useTranslation();

  const lang = props.lang;

  let refTimer;

  const trainingOptions = props.data?.optionalData?.trainingOptions;


  const cardio = trainingOptions?.find((option) => option.type === "cardio");
  const functional = trainingOptions?.find(
    (option) => option.type === "functional"
  );
  const freeweights = trainingOptions?.find(
    (option) => option.type === "freeweights"
  );
  const equipment = trainingOptions?.find(
    (option) => option.type === "equipment"
  );
  const rooms = trainingOptions?.find((option) => option.type === "rooms");

  const trainingOptionsArr = trainingOptions.map((option) => {return { 'image': getBaseUri() + option.image, 'text': option.text[lang], 'title': option.title[lang] }});

  let slides = (trainingOptionsArr.length > 0) ? trainingOptionsArr : [
    {
      image: `${process.env.PUBLIC_URL}/images/fallback_cardio.jpg`,
      title: cardio?.title[lang] ?? t("training.fallback_title_1"),
      text: cardio?.text[lang] ?? t("training.fallback_text_1"),
    },
    {
      image: `${process.env.PUBLIC_URL}/images/fallback_functional.jpg`,
      title: functional?.title[lang] ?? t("training.fallback_title_2"),
      text: functional?.text[lang] ?? t("training.fallback_text_2"),
    },
    {
      image: `${process.env.PUBLIC_URL}/images/fallback_weights.jpg`,
      title: freeweights?.title[lang] ?? t("training.fallback_title_3"),
      text: freeweights?.text[lang] ?? t("training.fallback_text_3"),
    },
    {
      image: `${process.env.PUBLIC_URL}/images/fallback_park.jpg`,
      title: equipment?.title[lang] ?? t("training.fallback_title_4"),
      text: equipment?.text[lang] ?? t("training.fallback_text_4"),
    },
    {
      image: `${process.env.PUBLIC_URL}/images/fallback_groupfitness.jpg`,
      title: rooms?.title[lang] ?? t("training.fallback_title_5"),
      text: rooms?.text[lang] ?? t("training.fallback_text_5"),
    },
  ];

  // const [slideIndex, setSlideIndex] = useState(0);

  const [tab, setTab] = useTabStore((state) => [state.tab, state.setTab]);

  useEffect(() => {
    return () => {
      clearTimeout(refTimer);
    };
  }, [refTimer]);

  const training_title = props.data.text?.training[lang]?.title && props.data.text?.training[lang]?.title != '' ? props.data.text.training[lang].title.replace(/{club}/g, props.data.name): t("training.title");
  const training_text = props.data.text?.training[lang]?.text && props.data.text?.training[lang]?.text != '' ? props.data.text.training[lang].text.replace(/{club}/g, props.data.name): false;

  return (
    <>
      <Transition
        show={tab === "training"}
        appear={true}
        unmount={false}
        // afterEnter={() => {
        //   refTimer = setTimeout(() => {
        //     sliderRef?.current?.flickity.resize();
        //   }, 10);
        // }}
      >
        <div className="tw-m-auto tw-max-w-screen-lg">
          <div className="tw-border-t tw-border-gray-medium tw-py-5">
            {/* <div className="tw-font-condensed tw-font-black tw-text-xl tw-uppercase tw-italic tw-leading-3 tw-p-5 tw-pt-8">
              <span className="tw-text-teal-dark">
                {slideIndex + 1}/{slides.length}
              </span>{" "}
              <span>{slides[slideIndex].title}</span>
            </div> */}
            <div className="tw-p-5 tw-pl-0 tw-font-condensed tw-font-black tw-text-3xl tw-uppercase tw-italic tw-hidden md:tw-block">
              {training_title}
            </div>
            {training_text !== false && (<SimpleText text={training_text} />)}
            <Swiper
              className="tw-mt-4"
              grabCursor={true}
              // onSwiper={(swiper) => {
              //   setSlideIndex(swiper.activeIndex);
              // }}
              // onSlideChange={(swiper) => {
              //   setSlideIndex(swiper.activeIndex);
              // }}
              slidesPerView={"auto"}
              centeredSlides={true}
              centeredSlidesBounds={true}
            >
              {slides.map((slideProps, index) => (
                <SwiperSlide
                  className={`tw-w-auto ${
                    index === 0 ? "tw-pl-0" : "tw-pl-2"
                  } ${index === slides.length - 1 ? "tw-pr-5" : ""}`}
                  key={"slider_item_" + index}
                >
                  <SliderItem
                    className="tw-w-[240px] tw-h-[380px]"
                    {...slideProps}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </Transition>
    </>
  );
}

export default TabTraining;
